export default "/images/vendor/vue-hotel-datepicker/dist/ic-arrow-right-green.regular.83ed3b6c.svg?93e0ea4a53918f0ee9bd9a32fc2e901d";